import { render, staticRenderFns } from "./AddDispatchCarReal.vue?vue&type=template&id=c27c9d92&scoped=true&"
import script from "./AddDispatchCarReal.vue?vue&type=script&lang=js&"
export * from "./AddDispatchCarReal.vue?vue&type=script&lang=js&"
import style0 from "./AddDispatchCarReal.vue?vue&type=style&index=0&id=c27c9d92&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27c9d92",
  null
  
)

export default component.exports